/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Shortage_Warning_AcceptInputs */

const vi_packaging_shortage_warning_accept = /** @type {(inputs: Packaging_Shortage_Warning_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vẫn xác nhận`)
};

/**

* @param {Packaging_Shortage_Warning_AcceptInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_shortage_warning_accept = /** @type {((inputs?: Packaging_Shortage_Warning_AcceptInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Shortage_Warning_AcceptInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_shortage_warning_accept(inputs)
});